







helpers = require('../../../helpers.coffee')

view_model = {
  props: ['notifications']
  components:
    listItem: require('./list_item')
}

exports.default = helpers.vue_include(view_model)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/list.vue